// Email login — replaces the Name Picker.
//
// Single text input for the user's @baam.com email. On submit calls
// /api/auth-lookup; a 200 returns the same employee record shape the
// directory emits (with bases[]), and we forward it to onResolved.
// 404 / network errors render inline. The picker entry point is gone:
// signing in is exclusively by email.

import { useState } from 'react';
import { api } from '../lib/api.js';

export default function EmailLogin({ onResolved }) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) return;
    setBusy(true);
    setError(null);
    try {
      const { employee } = await api.authLookup(trimmed);
      onResolved(employee);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-accent text-white font-bold text-lg mb-4">
            H
          </div>
          <h1 className="text-2xl font-semibold tracking-tight">HLPT Co-Pilot</h1>
          <p className="text-muted text-sm mt-1">Sign in with your @baam.com email</p>
        </div>

        <form onSubmit={submit}>
          <input
            autoFocus
            type="email"
            inputMode="email"
            autoComplete="email"
            placeholder="you@baam.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            disabled={busy}
            className="w-full px-4 py-3 rounded-lg bg-panel border border-border focus:border-accent focus:outline-none text-base placeholder:text-muted"
          />

          {error && (
            <div className="mt-3 p-3 rounded-lg border border-danger/30 bg-danger/10 text-sm text-danger">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={busy || !email.trim()}
            className="mt-3 w-full py-3 rounded-lg bg-accent hover:bg-accent2 disabled:opacity-50 disabled:hover:bg-accent text-white text-sm font-semibold transition-colors"
          >
            {busy ? 'Looking you up…' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
